import { Link } from 'react-router-dom';
import { seoSections } from '@/mocks/seoContent';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-6">
              {seoSections.whatIs.title}
            </h2>
            {seoSections.whatIs.paragraphs.map((p, idx) => (
              <p key={idx} className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4 max-w-xl">
                {p}
              </p>
            ))}
            <div className="mt-6 flex flex-wrap items-center gap-8">
              <div>
                <div className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading">1000+</div>
                <div className="text-xs text-foreground-400 mt-1">Curated Products</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading">14</div>
                <div className="text-xs text-foreground-400 mt-1">Product Categories</div>
              </div>
            </div>
            <div className="mt-8">
              <Link
                to="/hipobuy-spreadsheet-guide"
                className="inline-flex items-center space-x-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <span>Read Full Guide</span>
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>

          <div className="flex-1">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20boutique%20display%20with%20artisanally%20arranged%20textiles%20and%20accessories%20on%20minimal%20floating%20shelves%2C%20warm%20accent%20lighting%2C%20cream%20plaster%20walls%2C%20refined%20retail%20interior%2C%20soft%20shadows%2C%20luxury%20minimal%20aesthetic%2C%20high-end%20editorial%20photography&width=800&height=600&seq=about-showcase-v3&orientation=landscape"
                alt="Curated Hipobuy Spreadsheet product collection"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-4 left-4 bg-background-50 text-foreground-900 text-xs font-semibold px-3 py-1.5 rounded-full">
                2026 Collection
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-5">
                <div className="text-background-50 text-sm font-medium">Updated Weekly</div>
                <div className="text-background-50/70 text-xs">Trending Now</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}